/**
 * HomeIcon/index.js
 * desc: home feature main navigation icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const HomeIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="home icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.home.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg"><path d="M8 17v-6h4v6h5V9h3L10 0 0 9h3v8h5z"/></svg>
    </IconButton>
);


export default HomeIcon;
